import { ILanguage } from "../../../core/model/language/Language";
import { IIndexTypeCategory } from "../../../indexTypes/model/IndexTypeCategory";
import { IOrganisationIndexCategory } from "../../model/OrganisationIndexCategory";
import OrganisationIndexCategoryPresentationModel, {
  TOrganisationIndexCategoryPresentationModel
} from "./OrganisationIndexCategoryPresentationModel";

export interface TIndexTypeCategoryPresentationModel
  extends IIndexTypeCategory {
  organisationCategories: TOrganisationIndexCategoryPresentationModel[];
  nameTranslation: string;
}

const IndexTypeCategoryPresentationModel = (
  data: IIndexTypeCategory,
  organisationIndexCategories?: IOrganisationIndexCategory[],
  selectedLanguage?: ILanguage
) => {
  const organisationCategories = organisationIndexCategories?.filter(
    (value) => value.indexTypeCategoryId === data.id
  );

  const handler: ProxyHandler<IIndexTypeCategory> = {
    get: function (target, prop, receiver) {
      switch (prop) {
        case "organisationCategories":
          return organisationCategories?.map((category) => {
            const summary = category.nameTranslations.find(
              (item) => item.languageId === selectedLanguage?.id
            )?.nameTranslation;
            return OrganisationIndexCategoryPresentationModel(
              category,
              summary
            );
          });

        default:
          return Reflect.get(target, prop, receiver);
      }
    },
    set: function (target, prop, value, receiver) {
      switch (prop) {
        case "organisationCategories":
          return true;
        default:
          return Reflect.set(target, prop, value, receiver);
      }
    }
  };
  return new Proxy<IIndexTypeCategory, TIndexTypeCategoryPresentationModel>(
    data,
    handler
  );
};

export default IndexTypeCategoryPresentationModel;
